import styled from 'styled-components';
import { IThemeProvider } from '../../../../../styles/theme';

interface ColorBlockProps extends IThemeProvider {
  color: string;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ColorBlocks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  > * {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
`;

export const ColorBlock = styled.div<ColorBlockProps>`
  width: 40px;
  height: 18px;
  border-radius: 4px;
  ${({ color }) => `
    background: ${color};
  `}
`;

export const TogglerBlocks = styled.div`
  display: flex;
  margin-top: 1.5rem;
`;

export const Text = styled.span<IThemeProvider>`
  font-weight: 400;
  font-size: 12px;
  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[60]};
  `}
`;

export const VerticalContainer = styled.div<{ hasSecondColumn?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 5px;

  ${({ hasSecondColumn }) =>
    hasSecondColumn &&
    `
    margin-right: 5rem;
  `}
  > * {
    display: flex;
    justify-content: end;
    gap: 5px;
    align-items: center;
  }
`;
